import React, { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

const CheckboxWithTooltip = ({ checked, onChange, label, tooltip }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const tooltipRef = useRef(null);

  const toggleTooltip = (e) => {
    e.stopPropagation(); // prevent checkbox toggle
    e.preventDefault(); // prevent any default behavior
    setShowTooltip(!showTooltip);
  };

  // Close tooltip when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        setShowTooltip(false);
      }
    };

    if (showTooltip) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showTooltip]);

  return (
    <div style={{ marginBottom: "12px", position: "relative" }}>
      <label
        className="oe-checkbox-tooltip"
        style={{
          display: "flex",
          alignItems: "center",
          userSelect: "none",
          cursor: "pointer",
        }}
      >
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          style={{ marginRight: "8px", cursor: "pointer" }}
        />
        <span>{label}</span>
        <span
          ref={tooltipRef}
          onClick={toggleTooltip}
          style={{
            marginLeft: "8px",
            cursor: "pointer",
            display: "inline-flex",
            alignItems: "center",
            position: "relative",
          }}
        >
          <FontAwesomeIcon
            icon={faInfoCircle}
            className="info-icon"
            style={{
              color: showTooltip ? "#007bff" : "#6c757d",
              transition: "color 0.2s ease",
              fontSize: "14px",
            }}
          />
          {showTooltip && (
            <div
              className="tooltip-box"
              style={{
                position: "absolute",
                top: "100%",
                left: "50%",
                transform: "translateX(-10%)",
                marginTop: "8px",
                padding: "10px 12px",
                backgroundColor: "#333",
                color: "#fff",
                borderRadius: "6px",
                fontSize: "12px",
                whiteSpace: "normal",
                width: "max-content",
                maxWidth: "350px",
                zIndex: 1000,
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.3)",
                lineHeight: "1.5",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              {tooltip}
            </div>
          )}
        </span>
      </label>
    </div>
  );
};

export default CheckboxWithTooltip;
